import { Field } from 'formik';
import React from 'react';
import { Fieldset, Input } from '@fourthwall/components';
export const HeaderForm = () => {
    return (React.createElement(Fieldset.Row, null,
        React.createElement(Fieldset.Item, null,
            React.createElement(Field, { name: "content", component: Input, label: "Content", placeholder: "Header content" }))));
};
